const addTogglePrevNextBtnsActive = (emblaApi, prevBtns, nextBtns) => {
	const togglePrevNextBtnsState = () => {
		if (emblaApi.canScrollPrev()) {
			prevBtns.forEach(prevBtn => {
				prevBtn.removeAttribute("disabled", "disabled");
			});
		} else{
			prevBtns.forEach(prevBtn => {
				prevBtn.setAttribute("disabled", "disabled");
			});
		}

		if (emblaApi.canScrollNext()) {
			nextBtns.forEach(nextBtn => {
				nextBtn.removeAttribute("disabled", "disabled");
			});
		} else{
			nextBtns.forEach(nextBtn => {
				nextBtn.setAttribute("disabled", "disabled");
			});
		}
	};

	emblaApi
		.on("select", togglePrevNextBtnsState)
		.on("init", togglePrevNextBtnsState)
		.on("reInit", togglePrevNextBtnsState);

	return () => {
		prevBtn.removeAttribute("disabled");
		nextBtn.removeAttribute("disabled");
	};
};

export const addPrevNextBtnsClickHandlers = (emblaApi, prevBtns, nextBtns) => {
	const scrollPrev = (e) => {
		if(e.currentTarget.hasAttribute('data-slide-target')){
			emblaApi.scrollTo(parseInt(e.currentTarget.dataset.slideTarget), false, 'backward')
		} else{
			emblaApi.scrollPrev();
		}

	};
	const scrollNext = (e) => {
		console.log(e.currentTarget);
		if(e.currentTarget.hasAttribute('data-slide-target')){
			emblaApi.scrollTo(parseInt(e.currentTarget.dataset.slideTarget), false, 'forward')
		} else{
			emblaApi.scrollNext();
		}
	};

	prevBtns.forEach(prevBtn => {
		prevBtn.addEventListener("click", scrollPrev, false);
	});

	nextBtns.forEach(nextBtn => {
		nextBtn.addEventListener("click", scrollNext, false);
	});

	const removeTogglePrevNextBtnsActive = addTogglePrevNextBtnsActive(
		emblaApi,
		prevBtns,
		nextBtns
	);

	return () => {
		removeTogglePrevNextBtnsActive();

		prevBtns.forEach(prevBtn => {
			prevBtn.removeEventListener("click", scrollPrev, false);
		});

		nextBtns.forEach(nextBtn => {
			nextBtn.removeEventListener("click", scrollNext, false);
		});
	};
};
